import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { buyCase } from "./store/actions";
import Disclosure from "./Disclosure";
import { fetchCaseDamages } from "../DamageReports/BasicDamageReport/store/actions";
import { Button } from "../../common/components/Button";
import { requestCaseLoad } from "../Purchases/store/actions";

const RightSideButton = styled(Button)`
	marginright: 15px;
`;

const LeftSideButton = styled(Button)`
	float: right;
`;

const ButtonHolder = styled.div`
	margin-top: 40px;
`;

class Payment extends Component {
	state = {
		selectedCase: null,
		isAdminToken: null
	};

	componentDidMount() {
	this.setState({
		isAdminToken:
		localStorage.getItem("isAdminToken") === "false" ? false : true
	});
	setTimeout(() => {
		if (this.state.isAdminToken) {
		this.props.history.push("/cases");
		}
	}, 1);
	this.props.match.params.caseId = this.props.match.params.caseId
		? Number(this.props.match.params.caseId)
		: "";
	this.setState({ selectedCase: this.props.match.params.caseId });
	this.props.fetchCaseAndPurchases();
	}

	render() {
		const alreadyPurchased =
			this.props.boughtCases.filter(x => x === this.state.selectedCase)
			.length !== 0;

		if (!this.props.currentCase.availablePurchaseLevels) {
			this.props.fetchCaseDamages(this.state.selectedCase);
			return "";
		}

		let message = (
			<React.Fragment>
			<h3>{this.state.selectedCase} was already purchased</h3>
			<Button color="success" onClick={() => this.props.history.goBack()}>
				Go Back
			</Button>
			</React.Fragment>
		);

		if (!alreadyPurchased) {
			message = (
			<React.Fragment>
				<Disclosure />
				<ButtonHolder>
				{this.props.currentCase.availablePurchaseLevels.indexOf(
					"NO_EMBARGO"
				) !== -1 ? (
					<RightSideButton
					hoverBorderColor="darkgreen"
					onClick={() =>
						this.props.buyCase(
						this.state.selectedCase,
						"NO_EMBARGO",
						this.props.firmSettings.subscription
						)
					}
					>
					Confirm Commission
					</RightSideButton>
				) : null}
				<LeftSideButton
					hoverBorderColor="red"
					onClick={() => this.props.history.goBack()}
				>
					Decline
				</LeftSideButton>
				</ButtonHolder>
			</React.Fragment>
			);
		}

		return message;
	}
}

const mapStateToProps = state => {
	return {
	boughtCases: state.ownedCases.boughtCases,
	justBought: state.ownedCases.justBought,
	currentCase: state.currentCase.currentCase,
	firmSettings: state.firmSettings
	};
};

const mapDispatchToProps = dispatch => {
	return {
	buyCase: (caseId, commissionLevel, subscription) =>
		dispatch(buyCase(caseId, commissionLevel, subscription)),
	fetchCaseDamages: caseId => dispatch(fetchCaseDamages(caseId)),
	fetchCaseAndPurchases: () => {
		dispatch(requestCaseLoad());
	}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(Payment));



// WEBPACK FOOTER //
// ./src/components/Purchases/PurchaseComponent.js